import React, { useRef, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import NavBar from '../components/NavBar';
import UploadStateModal from '../components/UploadStateModal';
import { freeAccess } from '../providers/AuthProvider';
import OrganizationSyncProvider from '../providers/OrganizationSyncProvider';
import { NavigateWithinOrg } from '../utils/navigation';
import FeatureNotAvailableModal from '../components/FeatureNotAvailableModal';
import { useModalContext } from '../contexts/ModalContext';
import ProjectLibrary from './ProjectLibrary';
import ProjectDetails from './ProjectDetails';
import ProjectDetailsContextProvider from '../providers/ProjectDetailsContextProvider';

const MainApp = () => {
    const { modalText, setModalText } = useModalContext();

    const routes = [
        { path: '/projects', element: <ProjectLibrary /> },
        {
            path: '/projects/:projectId/*',
            element: (
                <ProjectDetailsContextProvider>
                    <ProjectDetails />
                </ProjectDetailsContextProvider>
            ),
        },
    ];

    return (
        <>
            <OrganizationSyncProvider />
            <div className="App">
                <FeatureNotAvailableModal
                    modalText={modalText}
                    onClose={() => setModalText(null)}
                />
                <NavBar />
                <div className="content">
                    <Routes>
                        <Route
                            path="/"
                            element={<NavigateWithinOrg to={'/projects'} />}
                        />
                        {routes.map((route) => {
                            return (
                                <Route
                                    key={route.path}
                                    path={route.path}
                                    element={route.element}
                                />
                            );
                        })}
                    </Routes>
                    <UploadStateModal />
                </div>
            </div>
            {/* )} */}
        </>
    );
};
export default MainApp;
